import { Pipe, PipeTransform } from '@angular/core';
import { BodyRowSelectionDisabledFactory } from '../types/body-row-selection-disabled-factory';

@Pipe({
  name: 'bodyRowSelectionDisabled',
  standalone: true,
})
export class BodyRowSelectionDisabledPipe<Item> implements PipeTransform {
  public transform(
    item: Item,
    bodyRowSelectionDisabledFn: BodyRowSelectionDisabledFactory<Item>,
  ): boolean {
    return bodyRowSelectionDisabledFn(item);
  }
}
